
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';

export default defineComponent({
  name: 'SelecionarCstPis',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: String || undefined,
    },
    codigosSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstEntradas: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstSaidas: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenericoTexto } = useTelaBase();

    const state = reactive({
      // listaCstPisSaidas: [] as IOptionString[],
      // listaCstPisEntradas: [] as IOptionString[],
      listaCstPis: [] as IOptionString[],
    });

    (async () => {
      // const listaCstPisEntradas = await new ServicoCenarioFiscal().obterListaPisCofinsEntradas();
      // state.listaCstPisEntradas = montaOpcoesComListaItemGenericoTexto(listaCstPisEntradas);

      // const listaCstPisSaidas = await new ServicoCenarioFiscal().obterListaPisCofinsSaidas();
      // state.listaCstPisSaidas = montaOpcoesComListaItemGenericoTexto(listaCstPisSaidas);
      const listaCstPis = await new ServicoCenarioFiscal().obterListaPisCofins();
      state.listaCstPis = montaOpcoesComListaItemGenericoTexto(listaCstPis);
    })();

    function obterCstPis():any {
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterCstPis(),
      set: (val: string) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: string[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
